/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Product_Image_Design_Badge_MissingInputs */

const vi_error_product_image_design_badge_missing = /** @type {(inputs: Error_Product_Image_Design_Badge_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có logo chứng nhận vừa bị xoá khỏi thư viện. Bỏ logo đó khỏi danh sách rồi lưu lại.`)
};

/**

* @param {Error_Product_Image_Design_Badge_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_design_badge_missing = /** @type {((inputs?: Error_Product_Image_Design_Badge_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_Design_Badge_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_design_badge_missing(inputs)
});